export default function Privacidade() {
  return (
    <section>
      <div className='container mx-auto mb-6'>
        <h3 className="font-semibold">Política de Privacidade</h3>
        <p>Última atualização: 01 de Março de 2026.</p>

      </div>
      <div className='container mx-auto mb-6'>
        Esta política descreve como o site henrycorretor.com.br coleta, utiliza e protege suas informações. Ao utilizar nossos serviços, você concorda com o tratamento de seus dados conforme descrito abaixo.
      </div>
      <div className='container mx-auto mb-6'>
        <h2>1. Dados Coletados</h2>
        Coletamos informações que você fornece voluntariamente e dados capturados automaticamente:

        Informações Pessoais: Nome, apelido, e-mail, telefone, endereço residencial e foto.

        Dados Técnicos: Endereço IP, cookies e registros de acesso para fins de segurança e análise.
      </div>
      <div className='container mx-auto mb-6'>
        <h2>2. Finalidade e Comunicação </h2>
        Os dados coletados são utilizados exclusivamente para a prestação de serviços de corretagem imobiliária.

        Atenção: É necessário fornecer um endereço de e-mail ou número de telefone válido para que possamos retornar seu contato e dar continuidade ao atendimento.
      </div>
      <div className='container mx-auto mb-6'>
        <h2>3. Compartilhamento e Armazenamento</h2>
        Não vendemos seus dados. Eles são armazenados em ambiente seguro e compartilhados apenas quando necessário para o cumprimento de obrigações legais ou para viabilizar a transação imobiliária solicitada pelo usuário.
      </div>
      <div className='container mx-auto mb-6'>
        <h2>4. Seus Direitos</h2>
        Conforme a LGPD (Brasil) e regulamentações internacionais, você tem o direito de acessar, corrigir, anonimizar ou excluir seus dados a qualquer momento.
      </div>
      <div className='container mx-auto mb-6'>
        <h2>5. Encarregado de Proteção de Dados - DPO (Data Protection Officer)</h2>
        Para exercer seus direitos ou tirar dúvidas sobre esta Política, entre em contato com nosso Encarregado:<br /><br />

        DPO: Rodrigo da Silva Sakae<br />
        E-mail: dpo@devsakae.com.br
      </div>
    </section>
  );
}

